export const TEST_ID = 'droneDetailsDrawerTabs';
